import { DateTime } from 'luxon';

import { PaymentTypes } from '@appTypes/enums';

import { PaymentLogsSliceState } from './types';

export const moduleName = 'paymentLogs';

export const UNIT_SUMMARY_ORDER = [
  { label: 'totalCash', tooltip: false },
  { label: 'feesReceivable', tooltip: true },
  { label: 'totalAssets', tooltip: true },
  { label: 'totalLiabilities', tooltip: true },
  { label: 'netAssets', tooltip: false },
] as const;

export const UNIT_PAYMENT_TYPES = [
  {
    label: 'paymentReceived',
    key: PaymentTypes.PAYMENT,
  },
  { label: 'paymentMade', key: PaymentTypes.CHARGE },
] as const;

export const LOGS_SORT_OPTIONS_KEYS = {
  LOG_DATE: 'logDate',
  CATEGORY: 'category',
  DESRIPTION: 'description',
} as const;

export const LOGS_SORT_OPTIONS = [
  { label: 'description', key: LOGS_SORT_OPTIONS_KEYS.DESRIPTION },
  { label: 'category', key: LOGS_SORT_OPTIONS_KEYS.CATEGORY },
  { label: 'log Date', key: LOGS_SORT_OPTIONS_KEYS.LOG_DATE },
] as const;

export const LOGS_FILTER_DATE_KEYS = {
  TO_DATE: 'toDate',
  FROM_DATE: 'fromDate',
  PAYMENT_DUE_DATE: 'paymentDueDate',
} as const;

export const NULLABLE_UNIT_LOGS_FILTER_KEYS = [
  LOGS_FILTER_DATE_KEYS.FROM_DATE,
  LOGS_FILTER_DATE_KEYS.PAYMENT_DUE_DATE,
] as string[];

export const LOGS_SORT_ORDER_OPTIONS = [
  { label: 'Oldest to Newest', key: 'ascend' },
  { label: 'Newest to Oldest', key: 'descend' },
] as const;

export const UNIT_QUERY_PAYMENT_TYPES = [
  { label: 'all', key: 'All' },
  { label: 'charge', key: PaymentTypes.CHARGE },
  {
    label: 'payment',
    key: PaymentTypes.PAYMENT,
  },
] as const;

export const QUERY_PAYMENT_TYPES = [
  { label: 'all', key: 'All' },
  { label: 'charge', key: PaymentTypes.CHARGE },
  { label: 'credit', key: PaymentTypes.CREDIT },
  {
    label: 'debit',
    key: PaymentTypes.DEBIT,
  },
  {
    label: 'payment',
    key: PaymentTypes.PAYMENT,
  },
] as const;

export const MEMBER_QUERY_TYPES = [
  { label: 'allMembers', key: 'all' },
  { label: 'adult', key: 'adult' },
  {
    label: 'youth',
    key: 'youth',
  },
] as const;

export const MEMBER_REGISTRATIONS_QUERY_TYPES = [
  { label: 'allRegisteredMembers', key: 'all' },
  { label: 'currentRegisteredMembers', key: 'current' },
  {
    label: 'pastRegisteredMembers',
    key: 'past',
  },
] as const;

export const MEMBER_PAYMENT_TYPES = [
  { label: 'charge', key: PaymentTypes.CHARGE },
  { label: 'credit', key: PaymentTypes.CREDIT },
  {
    label: 'debit',
    key: PaymentTypes.DEBIT,
  },
  {
    label: 'payment',
    key: PaymentTypes.PAYMENT,
  },
] as const;

export const API_DATE_FORMAT = 'YYYY-MM-DD';

export enum PAYMENT_LOG_TABS {
  ROSTER = 'roster',
  UNIT_TRANSACTIONS = 'unitTransactions',
  HISTORY = 'history',
}
export const emptyQueryLogs = {
  [PaymentTypes.CHARGE]: [],
  [PaymentTypes.CREDIT]: [],
  [PaymentTypes.DEBIT]: [],
  [PaymentTypes.PAYMENT]: [],
};

export const defaultPastMember = {
  isInactive: false,
  fullName: '',
  personGuid: '',
  logs: [],
};

export const initialSliceState: PaymentLogsSliceState = {
  paymentLogsActiveTab: PAYMENT_LOG_TABS.ROSTER,
  selectedRowKeys: [],
  searchFilter: '',
  userGuid: '',
  pastMember: defaultPastMember,
  selectedEditLog: undefined,
  filters: {
    memberType: {
      youths: true,
      adults: false,
    },
    balance: {
      positive: true,
      negative: true,
    },
    dates: {
      fromDate: null,
      toDate: DateTime.now().toISODate(),
    },
  },
  unitFilters: {
    paymentType: 'All',
    dates: {
      fromDate: null,
      toDate: DateTime.now().toISODate(),
      paymentDueDate: null,
    },
    searchFilter: '',
    sorter: {
      sortBy: 'logDate',
      order: 'ascend',
    },
  },
  sorter: {
    columnKey: 'name',
    order: 'ascend',
  },
  queriedLogsFilters: {
    paymentType: null,
    dates: {
      fromDate: '',
      toDate: '',
    },
    memberType: null,
    registrationType: null,
    firstName: null,
    lastName: null,
    description: null,
    category: null,
    memberId: null,
    dueDate: null,
    exactDueDate: null,
  },
  queriedLogs: emptyQueryLogs,
};

export const peopleFilters = {
  YOUTH: 'youths',
  ADULTS: 'adults',
} as const;

export const balanceFilters = {
  POSITIVE: 'positive',
  NEGATIVE: 'negative',
} as const;

export const MINIMUM_DATE =
  DateTime.fromISO('1910-01-01').toFormat('yyyy-MM-dd');

export const LOG_SORT_OPTIONS = ['logDate', 'category', 'description'];
